import { Year } from './Misc';
import { User } from './User';

export enum CustomFilterOperations {
  ApplyAndSaveFilter = 'ApplyAndSaveFilter',
  ApplyFilter = 'ApplyFilter',
}

export enum CustomFilterOptions {
  NewCustomFilter = 0,
  CleanCustomFilter = -1,
  UnsavedCustomFilter = -2,
}

export interface CustomFilterForm {
  operationNumber: string;
  operationName: string;
  esgStatus: string[];
  phase: string[];
  stages: string[];
  types: string[];
  espsPolicies: string[];
  countries: string[];
  members: User[];
  years: Year[];
  esgDocumentStatus: string[];
  divisions: string[];
  impactCategories: string[];
  esrr: string[];
  groups: string[];
  safeguardPerformances: string[];
  disasterRiskClassifications: string[];
  assessmentsDisclosures: string[];
  esgIndicators: string[];
  ermDateStart: Date | null;
  ermDateFinish: Date | null;
  closingDateStart: Date | null;
  closingDateFinish: Date | null;
  qrrDateStart: Date | null;
  qrrDateFinish: Date | null;
  approvalDateStart: Date | null;
  approvalDateFinish: Date | null;
  queryDate: Date | null;
}

export interface CustomFilterItem {
  id: number;
  number: string;
  type: string;
  espsPolicy: string;
  esgStatus: string;
  phase: string;
  stage: string;
  country: string;
  esgDocumentalStatus: string;
  division: string;
  impactCategory: string;
  esrr: string;
  groups: string;
  safeguardPerformance: string;
  disasterRiskClassification: string;
  assessmentsDisclosure: string;
  esgIndicators: string;
}

export interface SaveCustomFilter {
  id?: number;
  userId?: number;
  email: string;
  customFilters: CustomFilterForm;
  assigned: string | null;
  queryGroup: string;
  name: string;
}
